var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$fetchState.pending)?_c('skeleton-loader-page-head'):_c('div',[_c('guide-book-paper-page-header',{attrs:{"guide-book-paper":_vm.guideBookPaper}}),_vm._v(" "),_c('v-container',[_c('nuxt-child',{key:_vm.$route.params.guideBookPaperId,attrs:{"guide-book-paper":_vm.guideBookPaper}})],1),_vm._v(" "),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }